<template>
  <div class="home">
    <a-layout class="layout">
      <a-layout-header class="title">
        成睿软件在线学习系统
      </a-layout-header>
      <a-layout-content>
        <div class="pc" v-if="deviceType === 'pc'" :style="{ background: '#fff', padding: '12px', minHeight: '70vh' }">
          <div class="video-title">{{ data.title }} <a @click="cancel">返回</a></div>
          <div v-if="this.link" class="pc-video">
            <video-player
              class="video-player vjs-default-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
            >
            </video-player>
          </div>
          <div class="pc-description">视频简介：{{ data.description }}</div>
          <div class="pc-description">上传时间：{{ data.createdTime }}</div>
          <div class="pc-description">播放量：{{ data.playCount }}</div>
          <div class="pc-description">
            关键词：<a-tag :key="item" v-for="item in data.keyWords">{{ item }}</a-tag>
          </div>
        </div>
        <div class="notpc" v-else :style="{ background: '#fff', padding: '12px', minHeight: '70vh' }">
          <div class="video-title">{{ data.title }} <a @click="cancel">返回</a></div>
          <di v-if="this.link">
            <video-player
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
            >
            </video-player>
          </di>
          <div class="pc-description">视频简介：{{ data.description }}</div>
          <div class="pc-description">上传时间：{{ data.createdTime }}</div>
          <div class="pc-description">播放量：{{ data.playCount }}</div>
          <div class="pc-description">
            关键词：<a-tag :key="item" v-for="item in data.keyWords">{{ item }}</a-tag>
          </div>
        </div>
      </a-layout-content>
      <a-layout-footer class="footer">
        成睿软件在线学习系统 ©2020
      </a-layout-footer>
    </a-layout>
  </div>
</template>

<script>
  import { videoPlayer } from 'vue-video-player'
  import 'video.js/dist/video-js.css'

  export default {
    components: {
      videoPlayer
    },
    name: 'Detail',
    data() {
      return {
        playerOptions: {
          playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
          autoplay: false, // 如果为true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 是否视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            {
              type: 'video/mp4', // 类型
              src: '' // url地址
            }
          ],
          poster: '', // 封面地址
          notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true, // 当前时间和持续时间的分隔符
            durationDisplay: true, // 显示持续时间
            remainingTimeDisplay: false, // 是否显示剩余时间功能
            fullscreenToggle: true // 是否显示全屏按钮
          }
        },
        id: 0,
        type: 'pc',
        link: '',
        data: {}
      }
    },
    computed: {
      deviceType() {
        if (document.documentElement.clientWidth > 700) {
          return 'pc'
        } else {
          return 'mobile'
        }
      }
    },
    created() {
      this.id = this.$route.query.id
      this.getById()
    },
    methods: {
      cancel() {
        this.$router.push({ name: 'Home' })
      },
      getById() {
        this.apis.getVideosH5ById({ id: this.id }).then(response => {
          if (response.success) {
            this.data = response.data
            this.playerOptions.sources[0].src = this.data.link
            setTimeout(() => {
              this.link = this.data.link
            }, 100)
            console.log(this.playerOptions)
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .home >>> .ant-layout-header {
    padding: 0;
  }
  .title {
    font-size: 24px;
    color: white;
    font-weight: bolder;
  }

  .footer {
    text-align: center;
  }
  .pc {
    width: 70%;
    padding: 20px;
    margin: 0px auto;
    text-align: left;
  }
  .notpc {
    width: 100%;
    padding: 20px;
    margin: 0px auto;
    text-align: left;
  }
  .video-title {
    font-size: 24px;
    text-align: left;
  }
  .pc-description {
    font-size: 13px;
    color: #999;
    line-height: 30px;
  }

  .pc-video {
    padding: 20px;
  }
  .video-js >>> .vjs-big-play-button {
    line-height: 50px;
    height: 50px;
    width: 50px;
    border-radius: 19px;
    display: block;
    position: absolute;
    top: 40%;
    left: 40%;
  }
  .video-js {
    .vjs-control-bar {
      .vjs-icon-custombutton {
        font-family: VideoJS;
        font-weight: normal;
        font-style: normal;
      }
      .vjs-icon-custombutton:before {
        content: '\f108';
        font-size: 1.8em;
        line-height: 1.67;
      }
    }
  }
  /* .vjs-default-skin .vjs-big-play-button {left:40%;top:40%;} */
</style>
